
export enum ActionCd {
	ADD = 'Add',
	DELETE = 'Delete',
	NO_ACTION = 'NoAction',
	UPDATE = 'Update'}

